export default __webpack_public_path__ + "static/media/card_front_number.a445d873.svg";